/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { yieldTypes } from '../constants';
import { currencies, exchange } from '../../../utilities/constants';
import { formatNumber, formatNumberWithComma } from '../../../utilities/formatHelpers';

const YieldFilters = ({ onChangeType, selectedTab, rate, depositedList, receivedList }) => {
  const { t: translate } = useTranslation();

  if (isMobile) {
    return (
      <div className="flex-column-center px-3">
        <div className="text-center">
          <div className="d-flex flex-row justify-content-center">
            <p className="text-f6 text-shadow me-2">
              {translate('oxygen_yield_current_BTC_label')}
            </p>
            <p className="text-f6 text-dark">{`${rate?.price} ${currencies.USDC.fullName}`}</p>
          </div>
        </div>
        <div className="mt-3 w-100 rounded-4 flex-row-center bg-light border border-shadow">
          <button
            type="button"
            style={{ height: '2.5rem' }}
            className={`toggle-item ${
              selectedTab === yieldTypes.OFFERS && 'active'
            } btn w-50 py-2 px-4 rounded-4`}
            onClick={() => onChangeType(yieldTypes.OFFERS)}>
            {translate('oxygen_yield_offers_tab_label')}
          </button>
          <button
            type="button"
            style={{ height: '2.5rem' }}
            className={`toggle-item ${
              selectedTab === yieldTypes.DEPOSITED && 'active'
            } btn w-50 py-2 px-4 rounded-4`}
            onClick={() => onChangeType(yieldTypes.DEPOSITED)}>
            {translate('oxygen_yield_deposited_tab_label')}
          </button>
          <button
            type="button"
            style={{ height: '2.5rem' }}
            className={`toggle-item ${
              selectedTab === yieldTypes.RECEIVED && 'active'
            } btn w-50 py-2 px-4 rounded-4`}
            onClick={() => onChangeType(yieldTypes.RECEIVED)}>
            {translate('oxygen_yield_received_tab_label')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-row-center">
      <div className="col-7 rounded-4 flex-row-center bg-light border border-shadow ">
        <button
          type="button"
          style={{ height: '2.5rem' }}
          className={`toggle-item ${
            selectedTab === yieldTypes.OFFERS && 'active'
          } btn w-50 py-2 px-4 rounded-4`}
          onClick={() => onChangeType(yieldTypes.OFFERS)}>
          {translate('oxygen_yield_offers_tab_label')}
        </button>
        <button
          type="button"
          style={{ height: '2.5rem' }}
          className={`toggle-item ${
            selectedTab === yieldTypes.DEPOSITED && 'active'
          } btn w-50 py-2 px-4 rounded-4 text-nowrap`}
          onClick={() => onChangeType(yieldTypes.DEPOSITED)}>
          {translate('oxygen_yield_deposited_tab_label')}
          {depositedList.length > 0 && (
            <span className="ms-2 px-2 py-1 text-disabled rounded-max text-f6 badge">
              {depositedList && Array.isArray(depositedList) ? depositedList.length : 0}
            </span>
          )}
        </button>
        <button
          type="button"
          style={{ height: '2.5rem' }}
          className={`toggle-item ${
            selectedTab === yieldTypes.RECEIVED && 'active'
          } btn w-50 py-2 px-4 rounded-4 text-nowrap`}
          onClick={() => onChangeType(yieldTypes.RECEIVED)}>
          {translate('oxygen_yield_received_tab_label')}
          {receivedList.length > 0 && (
            <span className="ms-2 px-2 py-1 text-black rounded-max text-f6 badge">
              {receivedList && Array.isArray(receivedList) ? receivedList.length : 0}
            </span>
          )}
        </button>
      </div>
      <div className="col-5">
        <div className="d-flex flex-row justify-content-end">
          <p className="text-f6 text-shadow me-2">{translate('oxygen_yield_current_BTC_label')}</p>
          <p className="text-f6 text-dark">{`${formatNumberWithComma(
            formatNumber(rate?.price, exchange.FIAT_VALUE)
          )} ${currencies.USDC.fullName}`}</p>
        </div>
      </div>
    </div>
  );
};

export default YieldFilters;

YieldFilters.propTypes = {
  rate: PropTypes.object,
  depositedList: PropTypes.array,
  receivedList: PropTypes.array,
  onChangeType: PropTypes.func.isRequired,
  selectedTab: PropTypes.string.isRequired,
};

YieldFilters.defaultProps = {
  rate: {},
  depositedList: [],
  receivedList: [],
};
